import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as builder from "../../ducks/builder";
import Icon, { IconSize } from "@app/components/Icon/Icon";
import { routeTo } from "@app/helpers/RoutesHelper";
import ROUTES from "@app/router/Routes";

const HeaderMobile = ({ headerLogo, onBurgerClick }) => (
  <div className="kt-header-mobile kt-header-mobile--fixed">
    <button
      type="button"
      className="kt-header-mobile__burger"
      onClick={onBurgerClick}
      aria-label="Ouvrir le menu"
    >
      <Icon icon="bars" size={IconSize.TwoX} />
    </button>

    <Link to="/" className="kt-header-mobile__logo">
      <img alt="logo" src={headerLogo} />
    </Link>

    <div className="kt-header-mobile__toolbar">
      <Link to={routeTo(ROUTES.CUSTOMERS.PATH)} className="kt-header-mobile__search" aria-label="Recherche client">
        <Icon icon="search" size={IconSize.TwoX} />
      </Link>
    </div>
  </div>
);

const mapStateToProps = (store) => ({
  headerLogo: builder.selectors.getStickyLogo(store),
});

export default connect(mapStateToProps)(HeaderMobile);
